let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("21Q15")).then(() => parcelRequire('11TwH'));